module.exports = __webpack_public_path__ + "img/ic_bed_sandh_0.5bbbc629.png";